import adminApi from "./admin-api/index.js";

export default {
  adminApi,
};
